import React, { useState, useEffect } from 'react';
import { categories } from '../constants/categoryconstants';
import ImageDisplay from './imagedisplay';
import ProductAttribute from '../components/productattribute';
import { hasInactiveLayers } from '../helpers/modelhelper';
import mergeImages from 'merge-images';

const Wizard = (props) => {
    const { view } = props;
    let currentView = view ? view : 0;
    const currentViewCategory = categories.find(el => el.id === currentView).category
    const subCategories = categories.find(el => el.id === currentView).subCategories;
    const subCategoryNames = subCategories.map(x => x.category);
    const [completedLureb64, setCompletedLureb64] = useState('');
    const [completedLureUrl, setCompletedLureUrl] = useState('');
    const [attributes, setAttributes] = useState(props.selImg);
    const [hasIncativeLayers, setHasInactiveLayers] = useState(hasInactiveLayers(props.selImg));

    useEffect(() => {
        updateSelImg(props.selImg);
        setHasInactiveLayers(hasInactiveLayers(props.selImg));
    }, [props.selImg])
    
    const updateSelImg = (newSelImgs) => {
        setAttributes(newSelImgs);
    }

    const handleSaveToCartClick = () => {
        const { selImg, completedLureImageId, completedLureUrlId } = props;
        let mergedAttributes = [];

        selImg.forEach(att => {
            if (att.subCategories.length > 0) { att.subCategories.forEach(a => mergedAttributes.push(a)) }
            else { mergedAttributes.push(att) }
        });

        setUrl(completedLureUrlId);
        mergeImage(mergedAttributes, completedLureImageId);
    }

    

    const handleSaveToCart = () => {
        const { productId } = props;
        if (attributes && attributes[0] && !attributes[0].imageUrl) {
            alert('Oops! You need to choose a base color for your lure');
        } else if (hasInactiveLayers(attributes)) {
            alert('Your lure contains elements out of stock!');
        }
        else {
            window.AjaxCart.addproducttocart_lureBuilder(`addproducttocart/details/${productId}/1`, '#product-details-form', document.getElementById('add-to-cart-spinner'), document.getElementById('lurebuilder-addtocart-button'), resetLure);
        }
    }

    const resetLure = () => {
        props.resetLure();
    }

    const getImages = () => {
        return subCategoryNames.length > 0 ?
            props.images.filter(img => {
                return subCategoryNames.includes(img.category);
            }) :
            props.images.filter(img => {
                return img.category === currentViewCategory;
            });
    }

    const mergeImage = (images, id) => {
        let urls = images.filter(i => {
            return i.imageUrl !== null;
        }).map(u => u.imageUrl);

        mergeImages(urls, { width: 800, height: 450 })
            .then(b64 => {
                setCompletedLureb64(<ProductAttribute key="completedLure" checked={true} name={`product_attribute_${id}`} value={b64 ? b64.replace("data:image/png;base64,", "") : 'no image'} />);
                handleSaveToCart();
            });
    }

    const setUrl = (id) => {
        setCompletedLureUrl(<ProductAttribute key="completedLureUrl" checked={true} name={`product_attribute_${id}`} value={window.location.href} />);
    }

    const renderAttributes = () => {
        const { selImg } = props;
        const mergedAttributes = [];
        selImg.forEach(att => {
            if (att.subCategories.length > 0) { att.subCategories.forEach(a => mergedAttributes.push(a)) }
            else { mergedAttributes.push(att) }
        });
        return mergedAttributes.filter(a => a.attributeId).map((att, i) => {
            return (
                <ProductAttribute key={i} checked={true} name={`product_attribute_${att.attributeId}`} value={att.imageId !== null ? att.imageId : "0000"} />
            );
        });
    }

    return (
        <div className="col-md-5 col-sm-5 lurebuilder-wizard">
            {
                <ImageDisplay
                    category={props.category}
                    hasSubCategories={subCategories.length > 0 ? true : false}
                    images={getImages()}
                    handleImageClick={props.handleImageClick}
                    selectedImage={props.selectedImage}
                    selImg={props.selImg}
                    resetCategory={props.resetCategory}
                />
            }
            <form action="post" id="product-details-form">
                <div className="attributes">
                    <input type="radio" style={{ display: 'none' }} value="1" name={`addtocart_${props.productId}.EnteredQuantity`} />
                    {completedLureb64}
                    {completedLureUrl}
                    {renderAttributes()}
                </div>
            </form>
            <img src="#" alt="testimg" id="combinedimage" style={{ display: 'none' }} />
            <div className="lurebuilder-button-container fix-buttons">
                <button className={hasIncativeLayers ? "button lurebuilder-addtocart-button-disabled" : "button lurebuilder-addtocart-button"} id="lurebuilder-addtocart-button" onClick={!hasIncativeLayers ? handleSaveToCartClick: null}>
                    SAVE TO CART <i className="fa fa-spinner fa-spin add-to-cart-spinner-hide" id="add-to-cart-spinner"></i>
                </button>
                <button className="button lurebuilder-button" onClick={() => props.handleViewStep(true)}>
                    NEXT STEP
                </button>
                <button className="button lurebuilder-button previous" onClick={() => props.handleViewStep(false)}>
                    Previous step
                </button>
            </div>
        </div>
    )
}

export default Wizard;
